import {createShopifyImageUrl} from '@/utilities/create-shopify-image-url';
import {preloadImage} from '@/utilities/preload-image';
import {safeParseOrElse} from '@/utilities/safe-parse-or-else';
import register from 'preact-custom-element';
import {useEffect, useMemo} from 'preact/hooks';
import {z} from 'zod';
import GwpImageCarousel from './GwpImageCarousel';

function Loader({imageUrls: imageUrlsJson}: {imageUrls: string}) {
  const imageUrls = useMemo(
    () =>
      safeParseOrElse(z.array(z.string()), [], JSON.parse(imageUrlsJson)).map(
        (url) => createShopifyImageUrl(url, 640)
      ),
    [imageUrlsJson]
  );
  useEffect(() => imageUrls.forEach(preloadImage), [imageUrls]);

  return <GwpImageCarousel imageUrls={imageUrls} />;
}
register(Loader, 'gwp-image-carousel', ['imageUrls']);
